/**
 * Created by amu33 on 27/09/2016.
 */
import React from 'react';
import SocialMenu from '../../components/social-menu/social-menu.jsx';
import SocialData from '../../data/social.js';
/**
 * HomeView
 * @returns the layout of the home view
 */
const HomeView = () => {
    return (
        <div>

            <SocialMenu items={[SocialData.linkedin, SocialData.github, SocialData.twitter, SocialData.instagram]}/>

            <section className="summary">
                <h1>AMCODE</h1>
                <h2>Code. Test. Repeat.</h2>
                <p>Software consultant based in London, UK with over 15 years experience developing for companies such as <a href="http://www.amazon.com" target="_new">Amazon</a>, <a href="http://www.microsoft.com" target="_new">Microsoft</a> and <a href="http://www.sky.com" target="_new">Sky</a>.</p>
            </section>
        </div>
    );
};

export default HomeView;



/** WEBPACK FOOTER **
 ** ./app/views/home-view/home-view.jsx
 **/